import React from "react";
import TestimonialPropOne from "./TestimonialPropOne";
import SectionTitle2 from "../../elements/section-title2/SectionTitle2";

const TestimonialOne = () => {
  return (
    <div className="section section-padding">
      <div className="container">
        <SectionTitle2
          subtitle="Testimonial"
          title="From getting started"
          description="Hear It Straight from Our Satisfied Clients. See why we’re their top choice for maintenance"
          textAlignment="heading-left"
          textColor=""
        />
        <div className="row">
          <TestimonialPropOne colSize="col-lg-4" itemShow="3" />
        </div>
      </div>
    </div>
  );
};

export default TestimonialOne;
